import React, { Component } from 'react';
import './App.css';
import Nav from './components/nav';
import EmployerExperience from './components/employer-experience';
import CardholderExperience from './components/cardholder-experience';
import PaperlessTrees from './components/paperless-trees';

class App extends Component {

  render() {
    
    return (
      <div className="App">
        <Nav />
        <EmployerExperience />
        <CardholderExperience />
        <PaperlessTrees />
      </div>
    );
  }
}

export default App;
